import Head from "next/head";

function DocumentMeta(props: any) {
  const {
    title, description, image, meta = {}, keywords, robots, showOgTags = false, extraScript,
  } = props;
  return (
    <Head>

      <title>{title}</title>

      <meta name="description" content={description} />

      <meta robots={robots || meta.robots} />

      <meta name="keywords" content={keywords || (meta.name && meta.name.keywords)} />
      {
        showOgTags && (
          <>
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            {image && (<meta property="og:image" content={image} />)}
            <meta name="keywords" content={keywords || (meta.name && meta.name.keywords)} />
          </>
        )
      }
      {
        extraScript && (
          extraScript
        )
      }
    </Head>
  );
}

export default DocumentMeta;
